import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const ERROR_TEXT = "Algo no ha salido bien. Inténtalo otra vez.";
export const EMPTY_TEXT = "Aún no hay contenido aquí. Llegará pronto.";
export const SUCCESS_TEXT = "Listo. Ya puedes seguir avanzando.";
export const WELCOME_TEXT = "Hola, estás en un lugar seguro para entender lo que sientes.";

export function errorDetail(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string" && e?.response?.status === 400) return d;
  if (typeof d === "string" && e?.response?.status === 401) return d;
  return ERROR_TEXT;
}
